import React from "react";
import {
  FaCogs,
  FaTools,
  FaNetworkWired,
  FaLaptopCode,
  FaCheckCircle,
} from "react-icons/fa";

/* ================= IMAGE LINKS (YOU CAN REPLACE LATER) ================= */

const heroImg =
  "https://img.freepik.com/premium-photo/industry-40-smart-factory-interior-showcases-advanced-automation-machinery-robotics-futuristic-industrial-setting-innovation-generative-ai-illustrator_993599-2104.jpg?w=2000";

const plcImg =
  "https://tse3.mm.bing.net/th/id/OIP.DWkmUbUYTU6VcCndVhryLwHaDX?pid=Api&P=0&h=180";

const hmiImg =
  "https://blog.isa.org/hs-fs/hubfs/Imported_Blog_Media/HMI-design.jpg";

const scadaImg =
  "https://images.unsplash.com/photo-1555949963-aa79dcee981c?auto=format&fit=crop&w=800&q=80";

const networkImg =
  "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=800&q=80";

const industry4Img =
  "https://tse1.mm.bing.net/th/id/OIP.e95EZ0JRXHOUNmpL6bZ7FgHaEK?pid=Api&P=0&h=180";

const panelImg =
  "https://images.unsplash.com/photo-1621905251918-48416bd8575a?auto=format&fit=crop&w=800&q=80";

/* ================= COMPONENT ================= */

const Automation = () => {
  return (
    <div className="w-full bg-slate-900 text-white">

      {/* ================= HERO SECTION ================= */}
      <div className="relative w-full h-[70vh]">
        <img
          src={heroImg}
          alt="Industrial Automation"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-6">
          <h1 className="text-4xl md:text-6xl font-bold">
            Industrial Automation 4.0
          </h1>
          <p className="text-slate-300 text-lg md:text-xl mt-4 max-w-3xl">
            PLC • SCADA • HMI • IIoT • Smart Factory Solutions
          </p>
        </div>
      </div>

      {/* ================= AUTOMATION EXPERTISE ================= */}
      <div className="max-w-7xl mx-auto px-6 py-20">

        <h2 className="text-4xl font-bold text-center">
          Our Automation Expertise – Industry 4.0
        </h2>

        <p className="text-slate-300 text-center max-w-4xl mx-auto mt-4">
          We provide advanced Industry 4.0 automation solutions integrating
          PLC, SCADA, HMI, Industrial IoT and intelligent networking to build
          smart, connected and highly efficient factories.
        </p>

        {/* GRID 3 + 3 */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* PLC */}
          <div className="bg-slate-800 p-6 rounded-2xl shadow-lg hover:-translate-y-2 duration-300">
            <img src={plcImg} className="rounded-xl mb-4" alt="PLC Automation" />
            <h3 className="text-xl font-bold flex items-center gap-2">
              <FaCogs /> PLC Automation
            </h3>
            <p className="text-slate-300 mt-2">
              PLC programming, commissioning and troubleshooting using Siemens,
              Allen Bradley, Mitsubishi, Delta, Omron and Schneider PLCs.
            </p>
          </div>

          {/* HMI */}
          <div className="bg-slate-800 p-6 rounded-2xl shadow-lg hover:-translate-y-2 duration-300">
            <img src={hmiImg} className="rounded-xl mb-4" alt="HMI Development" />
            <h3 className="text-xl font-bold flex items-center gap-2">
              <FaLaptopCode /> HMI Development
            </h3>
            <p className="text-slate-300 mt-2">
              Interactive HMI screens with alarms, trends, diagnostics and
              real-time visualization for operators.
            </p>
          </div>

          {/* SCADA */}
          <div className="bg-slate-800 p-6 rounded-2xl shadow-lg hover:-translate-y-2 duration-300">
            <img src={scadaImg} className="rounded-xl mb-4" alt="SCADA Systems" />
            <h3 className="text-xl font-bold flex items-center gap-2">
              <FaTools /> SCADA Systems
            </h3>
            <p className="text-slate-300 mt-2">
              Real-time monitoring, historical data logging, alarms and remote
              supervisory control solutions.
            </p>
          </div>

          {/* Networking */}
          <div className="bg-slate-800 p-6 rounded-2xl shadow-lg hover:-translate-y-2 duration-300">
            <img src={networkImg} className="rounded-xl mb-4" alt="Networking" />
            <h3 className="text-xl font-bold flex items-center gap-2">
              <FaNetworkWired /> Industrial Networking
            </h3>
            <p className="text-slate-300 mt-2">
              Industrial communication using MODBUS, Profinet, Profibus,
              Ethernet/IP and secure Ethernet networks.
            </p>
          </div>

          {/* Industry 4.0 */}
          <div className="bg-slate-800 p-6 rounded-2xl shadow-lg hover:-translate-y-2 duration-300">
            <img src={industry4Img} className="rounded-xl mb-4" alt="Industry 4.0" />
            <h3 className="text-xl font-bold flex items-center gap-2">
              🤖 Industry 4.0 / IIoT
            </h3>
            <p className="text-slate-300 mt-2">
              Smart factory solutions using IIoT, cloud integration, data
              analytics and predictive maintenance.
            </p>
          </div>

          {/* Panel Design */}
          <div className="bg-slate-800 p-6 rounded-2xl shadow-lg hover:-translate-y-2 duration-300">
            <img src={panelImg} className="rounded-xl mb-4" alt="Panel Design" />
            <h3 className="text-xl font-bold flex items-center gap-2">
              ⚙️ Panel Design & Support
            </h3>
            <p className="text-slate-300 mt-2">
              Electrical control panel design, wiring, FAT/SAT testing and
              24×7 industrial maintenance support.
            </p>
          </div>

        </div>
      </div>

      {/* ================= WHY CHOOSE US ================= */}
      <div className="bg-slate-800 py-16">
        <h2 className="text-3xl font-bold text-center">
          Why Choose Us?
        </h2>

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
          {[
            "Experienced Automation Engineers",
            "Complete Industry 4.0 Solutions",
            "Reliable & Scalable Systems",
            "24/7 Industrial Support",
          ].map((item, index) => (
            <div key={index} className="flex items-center gap-4">
              <FaCheckCircle className="text-green-400 text-2xl" />
              <p>{item}</p>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default Automation;
